export default __webpack_public_path__ + "static/media/likool_logo.f1e1342a.png";